export default __webpack_public_path__ + "static/media/wireless.c97576d0.png";